import React, { useState, useEffect } from "react";
import {
  diffInDays,
  getCurrentDate,
  getCurrentMonthFirstDate,
  secondsToHHMM,
  timeToSeconds,
} from "../../Utilitie";
import { FaEraser, FaUpload } from "react-icons/fa";
import Loading from "../../Extra/Loading";
import { MdInsertChart } from "react-icons/md";
import SuccessMsg from "../../Extra/SuccessMsg";
import FailedMsg from "../../Extra/FailedMsg";
import axios from "axios";

const TWSCautionUpdate = ({ stn, sec }) => {
  const urlBlockPrefix = process.env.REACT_APP_URL_BLOCK_PREFIX;
  const currentDate = getCurrentDate();
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);
  const [globalDate, setGlobalDate] = useState(currentDate);
  const [startDate, setStartDate] = useState(getCurrentMonthFirstDate());
  const [endDate, setEndDate] = useState(getCurrentDate());

  const [show, setShow] = useState(false);
  const [gridData, setGridData] = useState([]);
  const [error, setError] = useState(false);
  const op = ["UP", "DN"];
  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${urlBlockPrefix}getTWSCaution?start=${startDate}&end=${endDate}`
      );
      if (response.data.status === "ok") {
        setGridData(response.data.daterange.data);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      setError(true);
    }
  };
  useEffect(() => {
    fetchData();
  }, []);
  const columnHead = [
    `tws_date`,
    "section_name",
    "station",
    "km",
    "line",
    "speed",
    "reason",
    "impose_date",
    "impose_time",
    "block_given_date",
    "point_no",
    // "cancel_date",
    // "cancel_time",
    "impose_block_days",
    "impose_cancel_days",
  ];

  const handleChange = (rowIndex, key, value) => {
    const newData = [...gridData];
    const updatedRow = { ...newData[rowIndex], [key]: value };

    /////////////////////
    // if (key === "impose_date" || key === "cancel_date") {
    //   const a = updatedRow.impose_date.slice(0, 10);
    //   const b = updatedRow.cancel_date.slice(0, 10);

    //   if (a && b) {
    //     updatedRow.impose_cancel_days = diffInDays(a, b);
    //   } else {
    //     updatedRow.impose_cancel_days = 0;
    //   }
    // }

    if (key === "impose_date" || key === "block_given_date") {
      const a = updatedRow.impose_date.slice(0, 10);
      const b = updatedRow.block_given_date.slice(0, 10);
      if (a && b) {
        updatedRow.impose_block_days = diffInDays(b, a);
      } else {
        updatedRow.impose_block_days = 0;
      }
    }

    /////////////////////

    newData[rowIndex] = updatedRow;
    setGridData(newData);
  };
  const sendToBackend = async () => {
    const FinalData = gridData.map(({ tws_date, ...rest }) => rest);
    setLoading(true);
    try {
      const res = await fetch(`${urlBlockPrefix}updateTWSCaution`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(FinalData),
      });
      const data = await res.json();
      setResult(data);
      setShow(true);
      fetchData();
      if (data.status === "ok");
    } catch (e) {
      setResult({ status: "failed", message: e.message });
      setShow(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="text-center mt-12">
      <div className="d-flex justify-content-between bg-dark text-white p-2 papaDiv">
        <h5 className="">Update data in tableTWS CAUTION </h5>
        <div>
          <div className="d-flex  align-items-center ">
            <b>From </b>
            <input
              type="date"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
              className="me-1"
            />

            <b>To </b>
            <input
              type="date"
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
              // className="form-control"
            />
            <button
              className="ms-1 btn btn-sm btn-outline-light"
              onClick={fetchData}
            >
              Fetch
            </button>
          </div>
        </div>
      </div>

      <div className="table-responsive">
        <table className="table table-bordered table-striped mb-4 text-center align-middle">
          <thead className="table-dark">
            <tr>
              {columnHead.map((head, index) =>
                head === "impose_block_days" ||
                head === "impose_cancel_days" ? null : (
                  <th key={index} style={{ border: "1px solid gray" }}>
                    {head}
                  </th>
                )
              )}
            </tr>
          </thead>

          <tbody>
            {gridData &&
              gridData.map((row, rowIndex) => (
                <tr key={rowIndex}>
                  {columnHead.map((col, colIndex) =>
                    col === "impose_block_days" ||
                    col === "impose_cancel_days" ? null : (
                      <td key={colIndex} style={{ border: "1px solid gray" }}>
                        {col === "tws_date" ? (
                          <input
                            disabled
                            type="date"
                            className="form-control"
                            value={row[col]?.slice(0, 10)}
                            onChange={(e) =>
                              handleChange(rowIndex, col, e.target.value)
                            }
                          />
                        ) : col === "impose_date" ||
                          col === "cancel_date" ||
                          col === "block_given_date" ? (
                          <input
                            type="date"
                            className="form-control"
                            value={row[col]?.slice(0, 10) || null}
                            style={{ width: "140px" }}
                            max={currentDate}
                            onChange={(e) =>
                              handleChange(rowIndex, col, e.target.value)
                            }
                          />
                        ) : col === "impose_time" || col === "cancel_time" ? (
                          <input
                            type="time"
                            className="form-control"
                            style={{ width: "100px", fontSize: "0.8rem" }}
                            value={
                              typeof row[col] === "number"
                                ? secondsToHHMM(row[col])
                                : row[col] || ""
                            }
                            onChange={(e) =>
                              handleChange(
                                rowIndex,
                                col,
                                timeToSeconds(e.target.value)
                              )
                            }
                          />
                        ) : col === "section_name" ||
                          col === "line" ||
                          col === "station" ? (
                          <select
                            className="form-control"
                            style={{ width: "100px", fontSize: "0.8rem" }}
                            value={row[col] || ""}
                            onChange={(e) =>
                              handleChange(rowIndex, col, e.target.value)
                            }
                          >
                            <option value="" hidden>
                              Select
                            </option>
                            {sec.map(
                              (item, i) =>
                                col === "section_name" && (
                                  <option key={i} value={item}>
                                    {item}
                                  </option>
                                )
                            )}{" "}
                            {stn.map(
                              (item, i) =>
                                col === "station" && (
                                  <option key={i} value={item}>
                                    {item}
                                  </option>
                                )
                            )}
                            {op.map(
                              (item, i) =>
                                col === "line" && (
                                  <option key={i} value={item}>
                                    {item}
                                  </option>
                                )
                            )}
                          </select>
                        ) : (
                          <input
                            type="text"
                            className="form-control"
                            value={row[col] || ""}
                            style={{ width: "80px", fontSize: "0.8rem" }}
                            onChange={(e) =>
                              handleChange(rowIndex, col, e.target.value)
                            }
                          />
                        )}
                      </td>
                    )
                  )}
                </tr>
              ))}
          </tbody>
        </table>
      </div>

      <div className="p-3">
        {result?.status === "ok" ? (
          <SuccessMsg
            head="Success"
            message={result?.message}
            show={show}
            setShow={setShow}
          />
        ) : (
          result && (
            <FailedMsg
              head="Failed"
              message={`${result?.message || ""}, ${result?.error || ""}`}
              show={show}
              setShow={setShow}
            />
          )
        )}
      </div>

      <div>
        <button
          className={`m-1 btn btn-sm btn-outline-success ${
            loading ? "disabled" : ""
          }`}
          onClick={sendToBackend}
        >
          <FaUpload /> Upload
        </button>
        {loading && <Loading />}
      </div>
    </div>
  );
};

export default TWSCautionUpdate;
